<template>
  <div>
    <!-- voltage -->
    <div class="md-layout">
      <label class="md-layout-item md-form-label md-size-10 mx-auto">{{$lang.menu.voltage}}</label>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('U_L1') }
              ]">
          <label>L1</label>
          <md-input
            v-model="generatorData.U.L1"
            data-vv-name="U_L1"
            name="U_L1"
            type="text"
            v-validate="modelValidations.voltage"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('U_L1')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">V</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('U_L2') }
              ]">
          <label>L2</label>
          <md-input
            v-model="generatorData.U.L2"
            data-vv-name="U_L2"
            name="U_L2"
            type="text"
            v-validate="modelValidations.voltage"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('U_L2')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">V</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('U_L3') }
              ]">
          <label>L3</label>
          <md-input
            v-model="generatorData.U.L3"
            data-vv-name="U_L3"
            name="U_L3"
            type="text"
            v-validate="modelValidations.voltage"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('U_L3')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">V</span>
        </md-field>
      </div>
    </div>

    <!-- current -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label mx-auto">{{$lang.menu.current}}</label>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('I_L1') }
              ]">
          <label>L1</label>
          <md-input
            v-model="generatorData.I.L1"
            data-vv-name="I_L1"
            name="I_L1"
            type="text"
            v-validate="modelValidations.current"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_L1')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">A</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('I_L2') }
              ]">
          <label>L2</label>
          <md-input
            v-model="generatorData.I.L2"
            data-vv-name="I_L2"
            name="I_L2"
            type="text"
            v-validate="modelValidations.current"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_L2')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">A</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('I_L3') }
              ]">
          <label>L3</label>
          <md-input
            v-model="generatorData.I.L3"
            data-vv-name="I_L3"
            name="I_L3"
            type="text"
            v-validate="modelValidations.current"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_L3')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">A</span>
        </md-field>
      </div>
    </div>

    <!-- φ I -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label mx-auto">φ I</label>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_I_L1') }
              ]"
        >
          <label>L1</label>
          <md-input
            v-model="generatorData.ANGLE_I.L1"
            data-vv-name="ANGLE_I_L1"
            name="ANGLE_I_L1"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_I_L1')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_I_L2') }
              ]"
        >
          <label>L2</label>
          <md-input
            v-model="generatorData.ANGLE_I.L2"
            data-vv-name="ANGLE_I_L2"
            name="ANGLE_I_L2"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_I_L2')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_I_L3') }
              ]"
        >
          <label>L3</label>
          <md-input
            v-model="generatorData.ANGLE_I.L3"
            data-vv-name="ANGLE_I_L3"
            name="ANGLE_I_L3"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_I_L3')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>
    </div>

    <!-- φ U -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label mx-auto">φ U</label>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_U_L1') }
              ]"
        >
          <label>L1</label>
          <md-input
            v-model="generatorData.ANGLE_U.L1"
            data-vv-name="ANGLE_U_L1"
            name="ANGLE_U_L1"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_U_L1')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_U_L2') }
              ]"
        >
          <label>L2</label>
          <md-input
            v-model="generatorData.ANGLE_U.L2"
            data-vv-name="ANGLE_U_L2"
            name="ANGLE_U_L2"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_U_L2')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field
          :class="[
                { 'md-error': errors.has('ANGLE_U_L3') }
              ]"
        >
          <label>L3</label>
          <md-input
            v-model="generatorData.ANGLE_U.L3"
            data-vv-name="ANGLE_U_L3"
            name="ANGLE_U_L3"
            type="text"
            v-validate="modelValidations.angle"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ANGLE_U_L3')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">°</span>
        </md-field>
      </div>
    </div>

    <!-- FREQ -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label mx-auto">{{$lang.charts.frequency}}</label>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[
                { 'md-error': errors.has('freq') }
              ]">
          <md-input
            v-model="generatorData.freq"
            data-vv-name="freq"
            name="freq"
            type="text"
            v-validate="modelValidations.frequency"
            class="input-field"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('freq')">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">Hz</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-15 mx-auto"></div>
      <div class="md-layout-item md-size-15 mx-auto"></div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    generatorData: {
      type: Object,
      default() {
        return {
          U: {
            L1: "240",
            L2: "240",
            L3: "240"
          },
          I: {
            L1: "1",
            L2: "1",
            L3: "1"
          },
          ANGLE_U: {
            L1: "0",
            L2: "60",
            L3: "120"
          },
          ANGLE_I: {
            L1: "60",
            L2: "60",
            L3: "60"
          },
          freq: "50"
        };
      }
    }
  },
  data() {
    return {
      modelValidations: {
        voltage: {
          required: true,
          max_value: 320,
          min_value: 100
        },
        current: {
          required: true,
          max_value: 120,
          min_value: 0
        },
        angle: {
          required: true,
          max_value: 360,
          min_value: 0
        },
        frequency: {
          required: true,
          max_value: 70,
          min_value: 40
        }
      }
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit("on-validated", true, { generator: this.generatorData });
        }
        return res;
      });
    }
  }
};
</script>

<style scoped>
.suffix-label {
  padding: 9px 5px 0 0 !important;
}

.input-field {
  min-width: 10px;
}
</style>